import React from 'react';
import { Layout, Menu, MenuProps } from 'antd';
import { useAppNavigation } from '@core/.';
import { MenuClickEventHandler } from 'rc-menu/lib/interface';
import { AppRoutes } from '@utils/.';
import {
  HomeOutlined,
  LikeOutlined,
  MailOutlined,
  MessageOutlined,
  QrcodeOutlined,
  StarOutlined,
  SettingOutlined,
  YoutubeOutlined,
  ThunderboltOutlined,
  ShareAltOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons';
import { FaShieldHalved } from 'react-icons/fa6';
import { getItem, MenuItem } from '@utils/menu.util';
import { BRAND_LOGO_CONSTRAST, BRAND_NAME } from '@constants/brand';
import { useParams } from 'react-router';
import { MIDDLE_STYLE } from '@constants/responsive';
import { TbApps } from 'react-icons/tb';

type Props = {};

const getNavigationItem = (
  label: React.ReactNode,
  key: AppRoutes,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group'
) => {
  return getItem(label, key, icon, children, type);
};

const NavigationItems: MenuProps['items'] = [
  getNavigationItem('Home', 'home', <HomeOutlined />),
  getNavigationItem('Answer Reviews', 'reviews', <LikeOutlined />),
  getNavigationItem('Generate Reviews', 'requests', <MessageOutlined />, [
    getNavigationItem('Email & SMS', 'requestEmailSMS', <MailOutlined />),
    getNavigationItem('QR Code', 'requestQrScanner', <QrcodeOutlined />),
    getNavigationItem('Manual Sharing', 'manualSharing', <ShareAltOutlined />),
    getNavigationItem('Auto Request', 'autoRequest', <ThunderboltOutlined />),
  ]),
  getNavigationItem('Showcase Reviews', 'widget', <StarOutlined />),
  getNavigationItem('Reputation Defender', 'inquiries', <FaShieldHalved />),
  getNavigationItem('Social Studio', 'studio', <YoutubeOutlined />),
  getNavigationItem('Integrations', 'integrations', <TbApps />),
  getNavigationItem('Settings', 'settings', <SettingOutlined />),
  getNavigationItem('Billings', 'subscription', <CheckSquareOutlined />),
];

const LeftSider = (props: Props) => {
  const { tabName } = useParams<{ tabName: AppRoutes }>();
  const { navigate } = useAppNavigation();
  const handleNavigation: MenuClickEventHandler = info => {
    navigate(info.key as AppRoutes);
  };

  return (
    <Layout.Sider width={270} breakpoint="lg" theme="dark">
      <div style={{ margin: '10px 0px 20px 0px', ...MIDDLE_STYLE, padding: '10px 0px' }}>
        <img src={BRAND_LOGO_CONSTRAST} alt={BRAND_NAME} style={{ width: 40 }} />{' '}
        <span style={{ color: 'white', fontWeight: 'bold', fontSize: 16, marginLeft: 10 }}>
          REVIEW CIRCLE
        </span>
      </div>
      <Menu
        theme="dark"
        mode="inline"
        onClick={handleNavigation}
        selectedKeys={[tabName]}
        items={NavigationItems}
      />
    </Layout.Sider>
  );
};

export default LeftSider;
